/*
|--------------------------------------------------------------------------
| Imports
|--------------------------------------------------------------------------
*/

import { Mesh, PerspectiveCamera, Vector3 } from 'three';

import { CameraGet, CameraGetDirection } from '~/Camera';
import { Ticker } from '~/Chrono';
import { SignalDispatch } from '~/Signal';

import { Sprite } from './Types';
import { SpriteAddSignal, SpriteRemoveSignal } from './Signals';

/*
|--------------------------------------------------------------------------
| Locals
|--------------------------------------------------------------------------
*/

let _sprites: Array<Sprite> = [];
let _camera: PerspectiveCamera = null;
let _spriteLookAt: Vector3 = null;

/*
|--------------------------------------------------------------------------
| Public Functions
|--------------------------------------------------------------------------
*/

/**
 * @return {void}
 */
export function SpriteAdd(mesh: Mesh): void
{
    let sprite: Sprite = { mesh, active: true };
    _sprites.push(sprite);
    SignalDispatch<SpriteAddSignal>('SpriteAdd', { target: sprite });
}

/**
 * @return {void}
 */
export function SpriteUpdate(ticker: Ticker): void
{
    let index = _sprites.length;

    while (index--) {
        let sprite = _sprites[index];

        if (sprite.active) {
            sprite.mesh.quaternion.identity();

            _spriteLookAt.copy(sprite.mesh.position);
            _spriteLookAt.add(CameraGetDirection());
            _spriteLookAt.y = sprite.mesh.position.y;

            sprite.mesh.lookAt(_spriteLookAt);
        } else {
            _sprites.splice(index, 1);
            SignalDispatch<SpriteRemoveSignal>('SpriteRemove', { target: sprite });
        }
    }
}

/**
 * @return {void}
 */
export function SpriteInit(): void
{
    _camera = CameraGet();
    _spriteLookAt = new Vector3;
}
